import { Category } from 'lib-knowledge-management-common/models/types';

/**
 * Checks if dropTargetId is a child or sub child of cat
 *
 * @param cat Category to check if dropTargetId is a child or sub child
 * @param dropTargetId Id of the category to check if it is a child or sub child
 * @returns True if dropTargetId is a child or sub child of cat
 */
export function hasMatchingChildCategory(
  cat: Category,
  dropTargetId: string,
): boolean {
  if (!cat.categories) return false;
  return !!cat.categories.find((c) => {
    if (c.id === dropTargetId) return true;
    if (
      c.categories &&
      c.categories.find((sub) => hasMatchingChildCategory(sub, dropTargetId))
    )
      return true;
  });
}
